import { getPatientEpi, getPatientHcm, getPatientQx, getPatientRecipe, getTokenHCM } from "./integration";
import { findPatientByFileNumber, findPatientByPassaport, findPatientByRut } from "./patient";
import { getContrarefPatientId } from "./contraref";
import { getContrarefSpontaneousPatientId } from "./contrarefSpontaneus";
import { getSamplesByRut } from "./tomamuestra";
import {
  // getInterconsultBySpecilatyStateDestinationRut,
  searchInterconsultByRut,
  getInterconsultByRut,
  // getInterconsultByStateDestinationRut,
  // getIcByStateDestinationPatient
} from "./interconsult";
import { ToastProgrammatic as Toast } from "buefy";
import { eventBus } from "./../main";
import moment from "moment";

export const proccessPatientFileNumber = (patient) => {
  const STABLISHMENT = JSON.parse(window.localStorage.getItem("stablishment"));
  if (STABLISHMENT == 1803) {
    return patient.file_number_hae;
  } else if (patient.file_number) {
    return patient.file_number;
  } else {
    ("Sin Registro");
  }
};
export const calculateAgeBreakdown = (date) => {
  let dateRequest = moment(date, "DD-MM-YYYY");
  let todayDate = moment(new Date(), "DD-MM-YYYY"); //Can change, based on the requirement
  let diffTime = moment(todayDate).diff(dateRequest);

  let duration = moment.duration(diffTime);
  let years = duration.years();
  let days = duration.days();
  let months = duration.months();
  return `${years} a, ${months} m, ${days} d`;
};
export const validateRut = (rut, dv) => {
  /* eslint-disable */
  let fullRut = rut + "-" + dv;
  fullRut = fullRut.replace("‐", "-");
  console.log(fullRut);
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(fullRut)) return false;
  /* eslint-enable */
  // var tmp     = rutCompleto.split('-');
  var digv = dv;
  if (digv == "K") digv = "k";

  return validateDv(rut) == digv;
};

function validateDv(T) {
  var M = 0,
    S = 1;
  for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
  return S ? S - 1 : "k";
}

export const isNumber = (evt) => {
  const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const keyPressed = evt.key;
  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault();
  }
};

export const formatRut = (rut) => {
  rut = clean(rut);

  let result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1);
  for (let i = 4; i < rut.length; i += 3) {
    result = rut.slice(-3 - i, -i) + "." + result;
  }

  return result;
};
export const formatMotherRut = (rut) => {
  rut = clean(rut);

  let result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1);
  for (let i = 4; i < rut.length; i += 3) {
    result = rut.slice(-3 - i, -i) + result;
  }

  return result;
};
function clean(rut) {
  return typeof rut === "string" ? rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase() : "";
}

async function searchSamples(resource, searchRut) {
  eventBus.$emit("loadSamplesByRut", {
    loading: true,
  });
  let dataSamples = await getSamplesByRut(resource, searchRut.split("-")[0].replace(/\./g, ""));
  console.log("SAMPLES", dataSamples);
  eventBus.$emit("loadSamplesByRut", {
    loading: false,
    samples: dataSamples,
  });
}

async function searchPatientQx(resource, searchRut) {
  eventBus.$emit("loadPatientQx", {
    loading: true,
  });
  let dataQx = await getPatientQx(resource, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
  eventBus.$emit("loadPatientQx", {
    loading: false,
    dataQx: dataQx,
  });
}

export const searchPatientEpi = async function searchPatientEpi(resource, searchRut) {
  eventBus.$emit("loadPatientEpi", {
    loading: true,
  });
  let dataEpi = await getPatientEpi(resource, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
  eventBus.$emit("loadPatientEpi", {
    loading: false,
    dataEpi: dataEpi,
  });
  return dataEpi;
};

async function searchPatientRecipe(resource, searchRut) {
  eventBus.$emit("loadPatientRecipe", {
    loading: true,
  });
  let dataRecipe = await getPatientRecipe(resource, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
  eventBus.$emit("loadPatientRecipe", {
    loading: false,
    dataRecipe: dataRecipe,
  });
}
// (patient_id, destination_node_id, "specialty", specialty);
async function searchPatientContraref(patient_id, destination_node_id, searchType, specialty) {
  eventBus.$emit("loadPatientContraref", {
    patient_id,
    destination_node_id,
    searchType,
    specialty,
    page: 1,
  });
}

async function searchPatientContrarefSpontaneous(patient_id, destination_node_id) {
  eventBus.$emit("loadPatientContrarefSpontaneous", {
    patient_id,
    destination_node_id,
    searchType: "patient",
    page: 1,
  });
}

async function searchPatientIcByPatientId(state, destination_node_id, patient_id, searchType, specialty) {
  eventBus.$emit("loadPatientIc", {
    dataSearch: {
      state,
      destination_node_id,
      patient_id,
      searchType,
      page: 1,
      specialty,
    },
  });
}

export const searchPatients = async (searchRut, state, destination_node_id, specialty, page, recurso) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataContrarrefs;
  let dataContrarrefsSpont;
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  let tokenIntegracion = await getTokenHCM(recurso);
  localStorage.setItem("tokenHCM", tokenIntegracion);

  console.log(tokenIntegracion);
  if (searchRut != null) {
    if (!validateRut(searchRut.split("-")[0].replace(/\./g, ""), searchRut.split("-")[1])) {
      Toast.open({
        message: "El rut ingresado no es válido",
        type: "is-warning",
        position: "is-top",
      });
    } else {
      let dataPatient = [];
      let dataInterconsult = [];
      let listRecipe = [];
      let findRut = searchRut.replace(/[.-]/g, "");
      dataPatient = await findPatientByRut(recurso, findRut);
      let patient_id;
      let dataHCM = [];
      if (!dataPatient && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
        if (searchRut.replace(/\./g, "").includes("-")) {
          let respuesta = await getPatientHcm(recurso, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = true;
        } else {
          let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
          let respuesta = await getPatientHcm(recurso, rutSplit, localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = false;
        }
      } else {
        dataPatient = {
          ...dataPatient,
          rut: formatRut(dataPatient.rut),
        };
        patient_id = dataPatient.id;

        searchSamples(recurso, searchRut.split("-")[0].replace(/\./g, ""));
        searchPatientQx(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientEpi(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientRecipe(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        visibleData = true;
        result = {
          patient_id,
          dataPatient,
          dataContrarrefs,
          dataContrarrefsSpont,
          dataSamples,
          dataQx,
          dataEpi,
          listRecipe,
          visibleData,
        };
      }
      let dataInterconsultPasive = [];
      if (specialty == 0 || specialty == null) {
        searchPatientIcByPatientId(state, destination_node_id, patient_id, "stablishment");

        searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "stablishment");
        searchPatientContraref(patient_id, destination_node_id, "allSpecialty");
        searchPatientContrarefSpontaneous(patient_id, destination_node_id);
      } else {
        searchPatientIcByPatientId(state, destination_node_id, patient_id, "specialty", specialty);
        searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "specialty", specialty);
        searchPatientContraref(patient_id, destination_node_id, "specialty", specialty);
        searchPatientContrarefSpontaneous(patient_id, destination_node_id);
      }
      result = {
        patient_id,
        dataPatient,
        dataContrarrefs,
        dataContrarrefsSpont,
        dataSamples,
        dataQx,
        dataEpi,
        listRecipe,
        dataInterconsult,
        dataInterconsultPasive,
        dataHCM,
        visibleData,
      };

      return result;
    }
  } else {
    Toast.open({
      message: "Error, Debe ingresar un rut",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatientsByPassport = async (searchPassport, state, destination_node_id, specialty, page, recurso) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataContrarrefs;
  let dataContrarrefsSpont;
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  let tokenIntegracion = await getTokenHCM(recurso);
  localStorage.setItem("tokenHCM", tokenIntegracion);

  if (searchPassport != null) {
    let dataPatient = [];
    let dataInterconsult = [];
    let listRecipe = [];
    dataPatient = await findPatientByPassaport(recurso, searchPassport);
    let patient_id;
    let dataHCM = [];
    if (!dataPatient) {
      dataHCM[0] = 1;
    } //Solo para que funcione
    dataPatient = {
      ...dataPatient,
      passport: dataPatient ? dataPatient.passport : null,
    };
    patient_id = dataPatient.id;
    searchPatientContraref(patient_id);
    searchPatientContrarefSpontaneous(patient_id);

    visibleData = true;
    result = {
      patient_id,
      dataPatient,
      dataContrarrefs,
      dataContrarrefsSpont,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      visibleData,
    };

    let dataInterconsultPasive = [];
    if (specialty == 0 || specialty == null) {
      searchPatientIcByPatientId(state, destination_node_id, patient_id, "stablishment");
      searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "stablishment");
    } else {
      searchPatientIcByPatientId(state, destination_node_id, patient_id, "specialty", specialty);
      searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "specialty", specialty);
    }
    result = {
      patient_id,
      dataPatient,
      dataContrarrefs,
      dataContrarrefsSpont,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      dataInterconsult,
      dataInterconsultPasive,
      dataHCM,
      visibleData,
    };

    return result;
  } else {
    Toast.open({
      message: "Error, Debe ingresar un pasaporte",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatientsAPS = async (searchRut, state, recurso) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataContrarrefs;
  let dataContrarrefsSpont;
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  let tokenIntegracion = await getTokenHCM(recurso);
  localStorage.setItem("tokenHCM", tokenIntegracion);
  if (searchRut != null) {
    if (!validateRut(searchRut.split("-")[0].replace(/\./g, ""), searchRut.split("-")[1])) {
      Toast.open({
        message: "El rut ingresado no es válido",
        type: "is-warning",
        position: "is-top",
      });
    } else {
      let dataPatient = [];
      let dataInterconsult = [];
      let listRecipe = [];
      let findRut = searchRut.replace(/[.-]/g, "");
      dataPatient = await findPatientByRut(recurso, findRut);
      let patient_id;
      let dataHCM = [];
      if (!dataPatient && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
        if (searchRut.replace(/\./g, "").includes("-")) {
          let respuesta = await getPatientHcm(recurso, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = true;
        } else {
          let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
          let respuesta = await getPatientHcm(recurso, rutSplit, localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = false;
        }
      } else {
        dataPatient = {
          ...dataPatient,
          rut: formatRut(dataPatient.rut),
        };
        patient_id = dataPatient.id;
        dataContrarrefs = await getContrarefPatientId(recurso, patient_id);
        dataContrarrefsSpont = await getContrarefSpontaneousPatientId(recurso, patient_id);
        dataSamples = await getSamplesByRut(recurso, searchRut.split("-")[0].replace(/\./g, ""));
        dataQx = await getPatientQx(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        dataEpi = await getPatientEpi(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        listRecipe = await getPatientRecipe(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        visibleData = true;
        result = {
          patient_id,
          dataPatient,
          dataContrarrefs,
          dataContrarrefsSpont,
          dataSamples,
          dataQx,
          dataEpi,
          listRecipe,
          visibleData,
        };
      }

      dataInterconsult = await getInterconsultByRut(recurso, findRut);
      let dataInterconsultPasive = await searchInterconsultByRut(recurso, findRut);
      result = {
        patient_id,
        dataPatient,
        dataContrarrefs,
        dataContrarrefsSpont,
        dataSamples,
        dataQx,
        dataEpi,
        listRecipe,
        dataInterconsult,
        dataInterconsultPasive,
        dataHCM,
        visibleData,
      };

      return result;
    }
  } else {
    Toast.open({
      message: "Error, Debe ingresar un rut",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatientWithIntegration = async (resource, searchRut) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let error = false;
  let patient_id;
  let dataPatient = [];
  let dataHCM = [];
  let noPatient = false;
  let tokenIntegracion = await getTokenHCM(resource);
  localStorage.setItem("tokenHCM", tokenIntegracion);
  if (searchRut != null) {
    if (!validateRut(searchRut.split("-")[0].replace(/\./g, ""), searchRut.split("-")[1])) {
      error = true;
    } else {
      let findRut = searchRut.replace(/[.-]/g, "");
      dataPatient = await findPatientByRut(resource, findRut);
      if (!dataPatient) {
        noPatient = true;
      } else {
        dataPatient = {
          ...dataPatient,
          rut: formatRut(dataPatient.rut),
        };
        patient_id = dataPatient.id;
      }
      // if (searchRut.replace(/\./g, "").includes("-") && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
      //   let respuesta = await getPatientHcm(resource, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
      //   dataHCM = respuesta.body;
      // } else if (JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
      //   let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
      //   let respuesta = await getPatientHcm(resource, rutSplit, localStorage.getItem("tokenHCM"));
      //   dataHCM = respuesta.body;
      // }
    }
    result = {
      patient_id,
      dataPatient,
      dataHCM,
      error,
      noPatient,
    };
    return result;
  } else {
    Toast.open({
      message: "Error, Debe ingresar un rut",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatientsAllHcmRut = async (recurso, searchRut) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  let noPatient = false;
  let patientNotFound = false;
  let tokenIntegracion = await getTokenHCM(recurso);
  localStorage.setItem("tokenHCM", tokenIntegracion);
  if (searchRut != null) {
    if (!validateRut(searchRut.split("-")[0].replace(/\./g, ""), searchRut.split("-")[1])) {
      result.error = true;
    } else {
      let dataPatient = [];
      let listRecipe = [];
      let findRut = searchRut.replace(/[.-]/g, "");
      dataPatient = await findPatientByRut(recurso, findRut);
      let patient_id;
      let dataHCM = [];
      if (!dataPatient && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
        noPatient = true;

        if (searchRut.replace(/\./g, "").includes("-")) {
          let respuesta = await getPatientHcm(recurso, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = true;
        } else {
          let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
          let respuesta = await getPatientHcm(recurso, rutSplit, localStorage.getItem("tokenHCM"));
          dataHCM = respuesta.body;
          if (dataHCM.Message == "Error.") {
            Toast.open({
              message: "Error, no se encuentra el paciente",
              type: "is-danger",
              position: "is-top",
            });
          }
          visibleData = false;
        }
      } else if (dataPatient) {
        dataPatient = {
          ...dataPatient,
          rut: formatRut(dataPatient.rut),
        };
        patient_id = dataPatient.id;
        searchSamples(recurso, searchRut.split("-")[0].replace(/\./g, ""));
        searchPatientQx(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientEpi(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientRecipe(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        visibleData = true;
        result = {
          patient_id,
          dataPatient,
          dataSamples,
          dataQx,
          dataEpi,
          listRecipe,
          visibleData,
          noPatient,
        };
      } else {
        patientNotFound = true;
      }

      result = {
        patient_id,
        dataPatient: dataPatient || null,
        dataSamples,
        dataQx,
        dataEpi,
        listRecipe,
        dataHCM,
        visibleData,
        noPatient,
        notFound: patientNotFound,
      };

      return result;
    }
  } else {
    result.error = true;
  }
  return result;
};

export const searchPatientsByPassportWithoutIC = async (recurso, searchPassport) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  if (searchPassport != null) {
    let dataPatient = [];
    let listRecipe = [];
    dataPatient = await findPatientByPassaport(recurso, searchPassport);
    let patient_id;
    let dataHCM = [];
    if (!dataPatient) {
      dataHCM[0] = 1;
    } //Solo para que funcione
    dataPatient = {
      ...dataPatient,
      passport: dataPatient ? dataPatient.passport : null,
    };
    patient_id = dataPatient.id;
    visibleData = true;
    result = {
      patient_id,
      dataPatient,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      visibleData,
    };

    result = {
      patient_id,
      dataPatient,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      dataHCM,
      visibleData,
    };

    return result;
  } else {
    Toast.open({
      message: "Error, Debe ingresar un pasaporte",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatientsAllFileNumber = async (recurso, searchRut, searchTabs) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  let noPatient = false;
  let tokenIntegracion = await getTokenHCM(recurso);
  localStorage.setItem("tokenHCM", tokenIntegracion);
  if (searchRut != null) {
    let dataPatient = [];
    let listRecipe = [];
    dataPatient = await findPatientByFileNumber(recurso, searchRut);
    console.log(dataPatient);
    // let findRut = dataPatient.rut.replace(/[.-]/g, "")
    // console.log(findRut);
    let patient_id;
    let dataHCM = [];
    if (!dataPatient && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
      noPatient = true;
      if (searchRut.replace(/\./g, "").includes("-")) {
        let respuesta = await getPatientHcm(recurso, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
        dataHCM = respuesta.body;
        if (dataHCM.Message == "Error.") {
          Toast.open({
            message: "Error, no se encuentra el paciente",
            type: "is-danger",
            position: "is-top",
          });
        }
        visibleData = true;
      } else {
        let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
        let respuesta = await getPatientHcm(recurso, rutSplit, localStorage.getItem("tokenHCM"));
        dataHCM = respuesta.body;
        if (dataHCM.Message == "Error.") {
          Toast.open({
            message: "Error, no se encuentra el paciente",
            type: "is-danger",
            position: "is-top",
          });
        }
        visibleData = false;
      }
    } else {
      dataPatient = {
        ...dataPatient,
        rut: formatRut(dataPatient.rut),
      };
      patient_id = dataPatient.id;
      if (!searchTabs) {
        searchSamples(recurso, searchRut.split("-")[0].replace(/\./g, ""));
        searchPatientQx(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientEpi(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
        searchPatientRecipe(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
      }
      visibleData = true;
      result = {
        patient_id,
        dataPatient,
        dataSamples,
        dataQx,
        dataEpi,
        listRecipe,
        visibleData,
        noPatient,
      };
    }

    result = {
      patient_id,
      dataPatient,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      dataHCM,
      visibleData,
      noPatient,
    };

    return result;
  } else {
    Toast.open({
      message: "Error, Debe ingresar un numero de ubicacion interno",
      type: "is-danger",
      position: "is-top",
    });
  }
};

export const searchPatients2 = async (dataToSearch, resource) => {
  //El formato para enviar rut es xx.xxx.xxx-x
  let result = {};
  // let dataContrarrefs;
  // let dataContrarrefsSpont;
  let dataSamples;
  let dataQx;
  let dataEpi;
  let visibleData = false;
  if (searchRut != null) {
    let dataPatient = [];
    let dataInterconsult = [];
    let listRecipe = [];
    let findRut = searchRut.replace(/[.-]/g, "");
    dataPatient = await findPatientByRut(recurso, findRut);
    let patient_id;
    let dataHCM = [];
    if (!dataPatient && JSON.parse(window.localStorage.getItem("stablishment")) == 1811) {
      if (searchRut.replace(/\./g, "").includes("-")) {
        let respuesta = await getPatientHcm(recurso, searchRut.replace(/\./g, "").split("-")[0], localStorage.getItem("tokenHCM"));
        dataHCM = respuesta.body;
        if (dataHCM.Message == "Error.") {
          Toast.open({
            message: "Error, no se encuentra el paciente",
            type: "is-danger",
            position: "is-top",
          });
        }
        visibleData = true;
      } else {
        let rutSplit = searchRut.replace(/[.-]/g, "").slice(0, -1);
        let respuesta = await getPatientHcm(recurso, rutSplit, localStorage.getItem("tokenHCM"));
        dataHCM = respuesta.body;
        if (dataHCM.Message == "Error.") {
          Toast.open({
            message: "Error, no se encuentra el paciente",
            type: "is-danger",
            position: "is-top",
          });
        }
        visibleData = false;
      }
    } else {
      dataPatient = {
        ...dataPatient,
        rut: formatRut(dataPatient.rut),
      };
      patient_id = dataPatient.id;

      searchSamples(recurso, searchRut.split("-")[0].replace(/\./g, ""));
      searchPatientQx(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
      searchPatientEpi(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
      searchPatientRecipe(recurso, searchRut.split("-")[0].replace(/\./g, ""), localStorage.getItem("tokenHCM"));
      visibleData = true;
      result = {
        patient_id,
        dataPatient,
        dataContrarrefs,
        dataContrarrefsSpont,
        dataSamples,
        dataQx,
        dataEpi,
        listRecipe,
        visibleData,
      };
    }
    let dataInterconsultPasive = [];
    if (specialty == 0 || specialty == null) {
      searchPatientIcByPatientId(state, destination_node_id, patient_id, "stablishment");

      searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "stablishment");
      searchPatientContraref(patient_id, destination_node_id, "allSpecialty");
      searchPatientContrarefSpontaneous(patient_id, destination_node_id);
    } else {
      searchPatientIcByPatientId(state, destination_node_id, patient_id, "specialty", specialty);
      searchPatientIcByPatientId("pasive", destination_node_id, patient_id, "specialty", specialty);
      searchPatientContraref(patient_id, destination_node_id, "specialty", specialty);
      searchPatientContrarefSpontaneous(patient_id, destination_node_id);
    }
    result = {
      patient_id,
      dataPatient,
      dataContrarrefs,
      dataContrarrefsSpont,
      dataSamples,
      dataQx,
      dataEpi,
      listRecipe,
      dataInterconsult,
      dataInterconsultPasive,
      dataHCM,
      visibleData,
    };

    return result;
  } else {
    Toast.open({
      message: "Error, Debe ingresar un rut",
      type: "is-danger",
      position: "is-top",
    });
  }
};
